// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { ERepair } from 'packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectRepairFilter } from 'shared/selectors/advancedFilters';

export const RepairContainer: FC = () => {
  const { value, options } = useSelector(selectRepairFilter);

  const onChange = useFilterChangeCallback();

  const handleRepairChange = useCallback(
    (repair: NonEmptyArray<ERepair> | null) => {
      onChange({ action: 'setRepair', arguments: [repair] });
    },
    [onChange],
  );

  return <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleRepairChange} />;
};
